// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"np-z","imageAndVideoCount":"op-z","imageAndVideoContainer":"pp-z","viewAllReviews":"qp-z"};